module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/3d97c0d2dd797f00c614c9c7bdde2850.png";